import { IModel, IPathMap, paths } from "makerjs";

export class Triangle implements IModel {
    public paths: IPathMap = {};
    
  constructor(base:number,height: number) {
    const halfBase =base/2;
  
    const baseLine = new paths.Line([[-halfBase,0],[halfBase,0]]);
    const rightLine = new paths.Line([[halfBase,0],[0, height]]);
    const leftLine = new paths.Line([[-halfBase,0],[0, height]]);
 
    this.paths = { baseLine, rightLine, leftLine }
  }
}
  